/* eslint-disable no-unsafe-optional-chaining */
import {
  Box,
  ButtonGroup,
  CheckIcon,
  Chip,
  Divider,
  DocumentIcon,
  EmptyStateDrawer,
  GKButton,
  GKSearchSelect,
  Grid2,
  IconButton,
  PopConfirm,
  Show,
  StarFillIcon,
  StarIcon,
  Tab,
  Tabs,
  Typography,
} from "components";
import UploadManagerFileUpload from "components/UploadManagerFileUpload";
import { useFetchQuery, useMutation } from "hooks/useQueries";
import { isEmpty, sortBy } from "lodash";
import { useState } from "react";
import { useFormContext } from "react-hook-form";
import { handleRemoveUnderscore } from "utils";
import { TRANSACTION_UPLOAD_CONTRACT_NOTE } from "utils/apiRoutes";
import axiosInstance from "utils/axiosInstance";
import { handleDownloadFile, refetchQuery } from "utils/helpers";
import { QueryKeys } from "utils/queryKey";

interface Props {
  favoriteUploadSamples?: any;
  setShowFavoriteModal?: any;
  menuOptions?: any;
  showFavoriteModal?: any;
  favoriteRefetch?: any;
  handleDeleteFav?: any;
  handleAddToFav?: any;
  facLoading?: any;
  id?: any;
  setAllFiles?: any;
  selectedId: any;
  setSelectedId: any;
}

const UploadStepOne = ({
  favoriteUploadSamples,
  id,
  setAllFiles,
  selectedId,
  setSelectedId,
  setShowFavoriteModal,
}: Props) => {
  const form = useFormContext();

  const templatesTabspWatch = form.watch("templatesTabs");

  const [uploadError, setUploadError] = useState<string | null>(null);

  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const [selectFavTemplateId, setSelectFavTemplateId] = useState(null);

  /** ===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===### */
  const { data: menuOptions } = useFetchQuery({
    key: [QueryKeys.UPLOAD_MANAGER_SELECT_OPTIONS],
    route: TRANSACTION_UPLOAD_CONTRACT_NOTE,
  });

  const { mutate: handleChangesFav } = useMutation({
    mutationFn: (data: any) =>
      axiosInstance.patch(`/transaction_upload/${data.id}/make_fav/`),
    onSuccess: () => {
      refetchQuery(QueryKeys.UPLOAD_MANAGER_FAVORITE_SAMPLES);
    },
  });
  /** ===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===###===### */
  const handleDownloadSampleFiles = () => {
    handleDownloadFile({
      name: form.getValues("fileObject.sampleFileName"),
      link: form.getValues("fileObject.sampleFileLink"),
    });
  };

  return (
    <>
      <form id={id} className="upload-step-2" style={{ width: "100%" }}>
        <Grid2 container spacing={1} size={12}>
          <Grid2
            size={12}
            display={"flex"}
            flexDirection={"column"}
            alignItems={"flex-start"}
          >
            <Tabs
              value={form.getValues("templatesTabs")}
              onChange={(e, val) => {
                form.reset({
                  ...form.formState.defaultValues,
                  templatesTabs: val,
                });
                setAllFiles([]);
                setSelectedId(null);
              }}
            >
              <Tab label="My Favourite" value={1} disableRipple />
              <Tab label="Gridkey Templates" value={0} disableRipple />
              <Tab label="Broker Template" value={2} disableRipple />
            </Tabs>
          </Grid2>
          <Show.When isTrue={templatesTabspWatch === 2}>
            <Grid2 size={6} container spacing={2}>
              <Grid2 size={12}>
                <GKSearchSelect
                  inputLabel="Select Broker"
                  getOptionLabel={(option) =>
                    handleRemoveUnderscore(option?.templateName) || option
                  }
                  options={menuOptions?.data || []}
                  onChange={(event, val) => {
                    const fileType =
                      menuOptions?.data?.find(
                        (item: any) => item?.templateName === val?.templateName,
                      )?.options?.length === 1
                        ? menuOptions?.data?.find(
                            (item: any) =>
                              item?.templateName === val?.templateName,
                          )?.options[0]?.fileType
                        : "";

                    const fileVersion =
                      menuOptions?.data?.find(
                        (item: any) => item?.templateName === val?.templateName,
                      )?.options[0]?.versions?.length === 1
                        ? menuOptions?.data?.find(
                            (item: any) =>
                              item?.templateName === val?.templateName,
                          )?.options[0]?.versions[0]?.value
                        : "";
                    const fileObject =
                      menuOptions?.data?.find(
                        (item: any) => item?.templateName === val?.templateName,
                      )?.options[0]?.versions?.length === 1
                        ? menuOptions?.data?.find(
                            (item: any) =>
                              item?.templateName === val?.templateName,
                          )?.options[0]?.versions[0]
                        : "";

                    setTimeout(() => {
                      form.setValue("favoriteType", "");
                      form.setValue("fileBrokerType", val?.templateName);
                      form.setValue("fileUploadType", "Stock");
                      form.setValue("fileType", fileType);
                      form.setValue("fileVersion", fileVersion);
                      form.setValue("fileObject", fileObject);
                      form.setValue("fileObject", fileObject);
                      form.setValue("fileObject", fileObject);
                    }, 100);
                  }}
                  value={form.getValues("fileBrokerType")}
                />
              </Grid2>
              <Show.When isTrue={!isEmpty(form.getValues("fileBrokerType"))}>
                <Grid2 size={12}>
                  <Divider />
                </Grid2>
                <Grid2 size={12}>
                  <Typography sx={{ mb: 1 }}>Select File Type</Typography>

                  {menuOptions?.data
                    ?.find(
                      (item: any) =>
                        item?.templateName === form.getValues("fileBrokerType"),
                    )
                    ?.options?.map((fileTypeItem: any) => {
                      return (
                        <Chip
                          label={
                            <Grid2 container alignItems={"center"} gap={"6px"}>
                              {form.getValues("fileType") ===
                                fileTypeItem?.fileType && <CheckIcon />}
                              <Typography fontSize={14} fontWeight={500}>
                                {fileTypeItem?.fileType}
                              </Typography>
                            </Grid2>
                          }
                          sx={{
                            mr: 1,
                            mb: 1,
                            borderRadius: 2,
                            p: 2,
                          }}
                          variant={"outlined"}
                          color={
                            form.getValues("fileType") ===
                            fileTypeItem?.fileType
                              ? "primary"
                              : "default"
                          }
                          onClick={() => {
                            form.setValue("favoriteType", "");
                            form.setValue("fileType", fileTypeItem?.fileType);
                            const fileVersion = menuOptions?.data
                              ?.find(
                                (item: any) =>
                                  item?.templateName ===
                                  form.getValues("fileBrokerType"),
                              )
                              ?.options?.find(
                                (item: any) =>
                                  item?.fileType === fileTypeItem?.fileType,
                              )?.versions[0]?.value;
                            const versionSampleAvailable = menuOptions?.data
                              ?.find(
                                (item: any) =>
                                  item?.templateName ===
                                  form.getValues("fileBrokerType"),
                              )
                              ?.options?.find(
                                (item: any) =>
                                  item?.fileType === fileTypeItem?.fileType,
                              )?.versions[0];
                            form.setValue("fileObject", versionSampleAvailable);
                            form.setValue("fileObject", versionSampleAvailable);
                            form.setValue("fileVersion", fileVersion);
                            form.setValue(
                              "sampleAvailable",
                              versionSampleAvailable?.sampleAvailable,
                            );
                          }}
                        />
                      );
                    })}
                </Grid2>
              </Show.When>
              <Show.When
                isTrue={
                  templatesTabspWatch === 2 &&
                  form.getValues("fileBrokerType") !== ""
                }
              >
                <Grid2 size={12}>
                  <Divider />
                </Grid2>
                <Grid2 size={12}>
                  <GKButton
                    variant="outlined"
                    color="dark"
                    disabled={
                      !form.getValues("fileVersion") ||
                      !form.getValues("fileBrokerType") ||
                      !form.getValues("fileType")
                    }
                    onClick={() => {
                      setShowFavoriteModal(true);
                    }}
                    startIcon={<StarIcon />}
                  >
                    Save as Template
                  </GKButton>
                </Grid2>
              </Show.When>
            </Grid2>
          </Show.When>
          <Show.When isTrue={form.getValues("templatesTabs") !== 2}>
            <Grid2 container size={6} spacing={1}>
              <Grid2
                size={12}
                container
                height={392}
                overflow={"auto"}
                className="hidden"
                display={"flex"}
                justifyContent={"center"}
                alignItems={"flex-start"}
                pr={1}
              >
                {favoriteUploadSamples?.data &&
                [...favoriteUploadSamples?.data?.favUpload.flat()]?.filter(
                  (data) => (templatesTabspWatch === 0 ? data : data?.isFav),
                )?.length === 0 ? (
                  <Box
                    display={"flex"}
                    justifyContent={"center"}
                    alignItems={"center"}
                    flexDirection={"column"}
                    gap={1}
                    p={2}
                  >
                    <img
                      alt=""
                      height={130}
                      src="/LandingPage/noDataImg.svg"
                      width={"auto"}
                    />
                    <Typography
                      fontWeight={600}
                      fontSize={18}
                      color={"var(--black)"}
                    >
                      {"No Data Found."}
                    </Typography>
                    <Typography
                      fontWeight={500}
                      fontSize={14}
                      color={"var(--neutral-500)"}
                    >
                      {"Sorry we don't have any related data to show."}
                    </Typography>
                  </Box>
                ) : (
                  <ButtonGroup fullWidth orientation="vertical">
                    {favoriteUploadSamples?.data &&
                      sortBy(
                        [
                          ...favoriteUploadSamples?.data?.favUpload.flat(),
                        ]?.filter((data) =>
                          templatesTabspWatch === 0 ? data : data?.isFav,
                        ),
                        [
                          (o) => {
                            return o.title;
                          },
                        ],
                      )?.map((dataItem: any, index) => {
                        // const totalLength =
                        //   favoriteUploadSamples?.data &&
                        //   [
                        //     ...favoriteUploadSamples?.data?.favUpload.flat(),
                        //   ]?.filter((data) =>
                        //     templatesTabs === 0 ? data : data?.isFav,
                        //   )?.length;
                        return (
                          <GKButton
                            key={index}
                            sx={{
                              padding: "14px 8px",
                              color: "#4F4F4F",
                              bgcolor:
                                selectedId === dataItem.id ? "#EEF5FA" : "",
                            }}
                            onClick={() => {
                              setSelectedId(dataItem?.id);
                              setUploadError(null);
                              if (dataItem?.type === "cash") {
                                form.reset();
                                form.setValue("fileUploadType", "Cash");
                                form.setValue("fileType", "cash");
                              } else if (dataItem?.type === "portfolio") {
                                form.reset();
                                form.setValue("fileUploadType", "Portfolio");
                              } else if (
                                [
                                  ...favoriteUploadSamples?.data?.favUpload.flat(),
                                ]?.find((data) => data?.id === dataItem?.id)
                                  ?.type === "temp"
                              ) {
                                form.reset();
                                form.setValue("sheetTypeName", dataItem?.title);
                                form.setValue("sheetTypeId", dataItem?.id);
                              } else {
                                form.reset();
                                form.setValue("favoriteType", dataItem?.id);
                                form.setValue(
                                  "fileType",
                                  [
                                    ...favoriteUploadSamples?.data?.favUpload?.flat(),
                                  ]?.find(
                                    (items: any) => items?.id === dataItem?.id,
                                  )?.fileType,
                                );
                                form.setValue(
                                  "fileUploadType",
                                  [
                                    ...favoriteUploadSamples?.data?.favUpload?.flat(),
                                  ]?.find(
                                    (items: any) => items?.id === dataItem?.id,
                                  )?.uploadFile,
                                );
                                form.setValue(
                                  "fileBrokerType",
                                  [
                                    ...favoriteUploadSamples?.data?.favUpload?.flat(),
                                  ]?.find(
                                    (items: any) => items?.id === dataItem?.id,
                                  )?.broker,
                                );
                                form.setValue(
                                  "fileVersion",
                                  [
                                    ...favoriteUploadSamples?.data?.favUpload?.flat(),
                                  ]?.find(
                                    (items: any) => items?.id === dataItem?.id,
                                  )?.version,
                                );
                                form.setValue(
                                  "sampleAvailable",
                                  [
                                    ...favoriteUploadSamples?.data?.favUpload?.flat(),
                                  ]?.find(
                                    (items: any) => items?.id === dataItem?.id,
                                  )?.sampleAvailable,
                                );
                              }
                              form.setValue("fileObject", dataItem);
                            }}
                          >
                            <Grid2 container size={12} spacing={1}>
                              <Grid2
                                size={6}
                                display={"flex"}
                                alignItems={"center"}
                                textAlign={"start"}
                              >
                                <Typography fontSize={13} fontWeight={500}>
                                  {dataItem?.title}
                                  {dataItem?.type !== "permanent" && (
                                    <Typography
                                      fontSize={11}
                                      fontWeight={500}
                                      textAlign={"start"}
                                      color="#697586"
                                    >
                                      {dataItem?.broker?.replace(/_/g, " ")}
                                    </Typography>
                                  )}
                                </Typography>
                              </Grid2>
                              <Grid2
                                size={6}
                                display={"flex"}
                                alignItems={"center"}
                                justifyContent={"flex-end"}
                                gap={1}
                              >
                                <Typography
                                  display={"flex"}
                                  alignItems={"center"}
                                  gap={"4px"}
                                  fontSize={12}
                                  fontWeight={500}
                                  color="#697586"
                                >
                                  <DocumentIcon
                                    height={12}
                                    width={12}
                                    color="#697586"
                                  />
                                  {dataItem?.fileType?.replace(/_/g, " ")}
                                </Typography>
                                <Divider
                                  orientation="vertical"
                                  sx={{ height: "12px" }}
                                />
                                <IconButton
                                  onClick={(e) => {
                                    if (dataItem.isFav) {
                                      setAnchorEl(e.currentTarget);
                                      setSelectFavTemplateId(dataItem?.id);
                                    } else {
                                      handleChangesFav({ id: dataItem?.id });
                                    }
                                  }}
                                >
                                  {dataItem?.isFav ? (
                                    <StarFillIcon
                                      color={"var(--primary-900)"}
                                    />
                                  ) : (
                                    <StarIcon />
                                  )}
                                </IconButton>
                                {/* <IconButton
                                  onClick={() =>
                                    handleDeleteFav({
                                      id: dataItem?.id,
                                      type: dataItem?.type,
                                    })
                                  }
                                >
                                  <DeleteIcon />
                                </IconButton> */}
                              </Grid2>
                            </Grid2>
                          </GKButton>
                        );
                      })}
                  </ButtonGroup>
                )}
              </Grid2>
            </Grid2>
          </Show.When>
          <Grid2
            size={6}
            display={"flex"}
            alignItems={"center"}
            justifyContent={"center"}
            flexDirection={"column"}
            height={392}
            px={1}
            overflow={"auto"}
          >
            <Show.When
              isTrue={!!form.getValues("fileObject")}
              showNodata
              textContent="No template selected yet"
              secondTextContent="Choose a template from the left to begin importing your file."
              emptyIcon={<EmptyStateDrawer />}
              withBorder={false}
            >
              <UploadManagerFileUpload
                uploadError={uploadError}
                setUploadError={setUploadError}
                showSupportedFormat={false}
                acceptType={".csv, .pdf,.xlsx,.html,.htm,.xls"}
                value={form.getValues("file")}
                supportName="CSV or PDF or XLSX"
                onChange={(event) => {
                  form.setValue("file", event);
                  setAllFiles(
                    event?.map((data) => {
                      return {
                        file: data,
                        isFinished: false,
                      };
                    }),
                  );
                }}
                multiple
                sampleFile={{
                  isTrue: form.getValues("sampleAvailable"),
                  onclick: () => handleDownloadSampleFiles(),
                  btnName: "Download Template",
                  link: form.getValues("fileObject")?.sampleFileLink,
                }}
              />
            </Show.When>
          </Grid2>
        </Grid2>
      </form>

      {Boolean(anchorEl) && (
        <PopConfirm
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          setOpen={setAnchorEl}
          modalTitle="Remove from Favourites?"
          message="Unfavouriting this template will permanently delete it from the system."
          confirmIcon={<StarIcon />}
          onSuccess={() => {
            handleChangesFav({ id: selectFavTemplateId });
            setSelectFavTemplateId(null);
          }}
          confirmBtnText="Yes, Unfavourite it!"
          minWidth="390px"
        />
      )}
    </>
  );
};

export default UploadStepOne;
